import React, { Component } from "react";
import _ from "lodash";
import SplitText from "react-pose-text";
import { BackgroundImage, MyWaypoint } from "../../components";

export default class Section6 extends Component {
  state = {
    datas: null
  };
  componentDidMount = () => {
    this.fetchImage();
  };

  fetchImage = async () => {
    // use this website to get an access_token => https://elfsight.com/service/generate-instagram-access-token/
    const url =
      "https://api.instagram.com/v1/users/self/media/recent/?access_token=297944310.2e11369.215b67811c9f4746a9312d89353baebe&count=8";

    const result = await fetch(url)
      .then(res => res.json())
      .then(res => {
        const datas = _.get(res, "data");
        this.setState({ datas });
        return datas;
      })
      .catch(error => {
        console.log("fetchImage error", error);
      });
    return result;
  };
  render() {
    const { datas } = this.state;
    return (
      <div className="section-6">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-xl-9 order-1 order-xl-0">
              <div className="container-ig-image">
                {_.map(datas, data => {
                  const { images } = data;
                  return (
                    <a href={data.link} target="_blank" key={data.id}>
                      <div className="container-img">
                        <BackgroundImage
                          image={images.standard_resolution.url}
                        />
                        <div className="img-hover">
                          <span>
                            <i className="fa fa-heart" /> {data.likes.count}
                          </span>
                          <span>
                            <i className="fa fa-comment" />{" "}
                            {data.comments.count}
                          </span>
                        </div>
                      </div>
                    </a>
                  );
                })}
              </div>
            </div>
            <div className="col-xl-3 order-0 order-xl-1">
              <div className="container-title">
                <div className="title">
                  <MyWaypoint>
                    <h2>
                      {/* <SplitText
                        initialPose="exit"
                        pose="enter"
                        charPoses={{
                          exit: { opacity: 0 },
                          enter: {
                            opacity: 1,
                            transition: ({ charInWordIndex }) => ({
                              type: 'spring',
                              delay: charInWordIndex * 60,
                              stiffness: 150,
                              damping: 40
                            })
                          }
                        }}
                      > */}
                      Instagram Hashtag
                      {/* </SplitText> */}
                    </h2>
                  </MyWaypoint>
                </div>
                <MyWaypoint>
                  <h3>
                    <SplitText
                      initialPose="exit"
                      pose="enter"
                      charPoses={{
                        exit: { opacity: 0.5 },
                        enter: {
                          opacity: 1,
                          delay: ({ charIndex }) => charIndex * 100
                        }
                      }}
                    >
                      #Tiffany’sShow
                    </SplitText>
                  </h3>
                </MyWaypoint>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/Section6.js